import { render } from "./MovimentacaoView.vue?vue&type=template&id=14e6879b"
import script from "./MovimentacaoView.vue?vue&type=script&lang=js"
export * from "./MovimentacaoView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__